var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 178,
    viewBox: "0 0 177 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.7305,
    y: 89.7266,
    width: 54.3986,
    height: 54.3986,
    transform: "rotate(-45 72.7305 89.7266)",
    fill: "#FF5982"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.457,
    y: 46.4531,
    width: 54.3986,
    height: 54.3986,
    transform: "rotate(-45 29.457 46.4531)",
    fill: "#DA1B5E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.457,
    y: 133.004,
    width: 54.3986,
    height: 54.3986,
    transform: "rotate(-45 29.457 133.004)",
    fill: "#DA1B5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImage);
export default __webpack_public_path__ + "static/media/AuthImage.dfe64b1c9985dc086b67c4d1369ab795.svg";
export { ForwardRef as ReactComponent };